import { render } from "./ReviewUserDetails.vue?vue&type=template&id=dc9460f8"
import script from "./ReviewUserDetails.vue?vue&type=script&lang=js"
export * from "./ReviewUserDetails.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__